import Detail from './detail'

export default [{
    path: '/article/:id',
    name:'article-detail',
    component: Detail
}]
